export default __webpack_public_path__ + "static/media/logo.336213f2.png";